import script from "./Permissions.vue?vue&type=script&setup=true&lang=ts"
export * from "./Permissions.vue?vue&type=script&setup=true&lang=ts"

import "./Permissions.vue?vue&type=style&index=0&id=6b088cc0&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b088cc0"]])

export default __exports__